import { Dispatch } from "redux";
import { connect } from "react-redux";
import { Action } from "typescript-fsa";

import {
    ApiButton as Presenter,
    ApiButtonStateProps,
    ApiButtonDispatchProps,
    ApiButtonOwnProps,
} from "./presenter";
import { ApiState } from "../../models/state";
import { ApiRequest } from "../../requests";
import { getAllRequests } from "../../selectors";

// Map the api state to the component.
function mapStateToProps(state: ApiState, _ownProps: ApiButtonOwnProps) {
    return {
        requests: getAllRequests(state),
    } as ApiButtonStateProps;
}

function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: ApiButtonOwnProps) {
    return {
        dispatchActionCreators: ownProps.actionCreators.map((actionCreator) =>
            () => {
                const action = actionCreator();
                if (action instanceof Promise) {
                    return passPromise(action, dispatch);
                }
                else {
                    dispatch(action);
                    return action;
                }
            }),
    } as ApiButtonDispatchProps;
}

function passPromise(promise: Promise<Action<ApiRequest>>, dispatch: Dispatch<any>) {
    return new Promise(
        (resolve: (value?: any) => void, reject: (reason?: any) => void) => {
            promise.
                then(
                    (action: Action<ApiRequest>) => {
                        dispatch(action);
                        resolve(action);
                    },
                ).
                catch((reason?: any) => reject(reason));
        },
    );
}

// Connect the component to Redux.
const ApiButton = connect(mapStateToProps, mapDispatchToProps)(Presenter);

export { ApiButton };
